/** Переключатель темы: система / светлая / тёмная. */
import { Monitor, Moon, Sun } from 'lucide-react'
import { useTheme, type ThemeChoice } from '@/shared/lib/theme'
import { cn } from '@/shared/lib/cn'

const OPTIONS: Array<{ value: ThemeChoice; label: string; Icon: typeof Sun }> = [
  { value: 'system', label: 'Как в системе', Icon: Monitor },
  { value: 'light', label: 'Светлая тема', Icon: Sun },
  { value: 'dark', label: 'Тёмная тема', Icon: Moon },
]

export function ThemeToggle() {
  const { choice, setChoice } = useTheme()
  return (
    <div
      role="radiogroup"
      aria-label="Оформление"
      className="inline-flex rounded-md border border-line bg-surface p-0.5"
    >
      {OPTIONS.map(({ value, label, Icon }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={choice === value}
          aria-label={label}
          title={label}
          onClick={() => setChoice(value)}
          className={cn(
            'inline-flex size-9 items-center justify-center rounded-[0.4rem]',
            'transition-colors duration-DEFAULT',
            choice === value
              ? 'bg-raised text-ink'
              : 'text-ink-muted hover:text-ink-soft',
          )}
        >
          <Icon aria-hidden className="size-4" />
        </button>
      ))}
    </div>
  )
}
